module.exports = __webpack_public_path__ + "img/Live-Updates.1f79cd44.png";